import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook that sends a page_view event to GA4 on every route change.
 * Works inside a <Router> context.
 */
const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);
};

export default useGoogleAnalytics;
